

/**
 * @name CollectorUpdateController
 * @description Controller for the profile update component
 * @param {object} Session The session service
 */
function CollectorUpdateController(
  Session
) {
  let vm = this;
  vm.session = Session;
}

angular
  .module('inkfinder')
  .controller('CollectorUpdateController', CollectorUpdateController);



// WEBPACK FOOTER //
// ./components/collector/update/update.controller.js